/* eslint-disable
    no-loop-func,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import {assert} from 'Asserts';

enum EditAction {
  NO_CHANGE = 'NO_CHANGE',
  SUBSTITUTION = 'SUBSTITUTION',
  INSERTION = 'INSERTION',
  DELETION = 'DELETION',
}

interface Edit {
  index: number;
  initial: string;
  final: string;
}

export interface BaseEdit extends Edit {
  action: EditAction;
}

function extractModifiedRegion(
  original: string,
  final: string
): {
  index: number;
  original: string;
  final: string;
} {
  const minLength = Math.min(original.length, final.length);

  let i = 0;
  while (original[i] === final[i] && i < minLength) {
    i++;
  }
  // i now equals the first index of disagreement, or minLength.

  let j = 0;
  while (original[original.length - j - 1] === final[final.length - j - 1] && j < minLength - i) {
    j++;
  }

  return {
    index: i,
    original: original.slice(i, original.length - j),
    final: final.slice(i, final.length - j),
  };
}

// Returns edits in descending order by index.
function getBaseEdits(a: string, b: string): {baseEdits: Array<BaseEdit>; distance: number} {
  let i;
  let j;
  let asc;
  let end;
  let asc1;
  let end1;
  let asc2;
  let end2;
  const editDistances = []; // editDistances[i][j] is the minimum edit distance between a[:i] and b[:j]
  const edits = []; // edits[i][j] is the operation used to compute editDistances[i][j]
  // edits[0][0] doesn't matter

  // The minimum distance between a[:i] and '' is i.
  // eslint-disable-next-line benchlint/disallow-comma-operator
  for (i = 0, end = a.length + 1, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
    editDistances[i] = [i];
    edits[i] = [EditAction.DELETION];
  }

  // The minimum distance between '' and b[:j] is j.
  // eslint-disable-next-line benchlint/disallow-comma-operator
  for (j = 0, end1 = b.length + 1, asc1 = 0 <= end1; asc1 ? j < end1 : j > end1; asc1 ? j++ : j--) {
    editDistances[0][j] = j;
    edits[0][j] = EditAction.INSERTION;
  }

  // eslint-disable-next-line benchlint/disallow-comma-operator
  for (i = 1, end2 = a.length + 1, asc2 = 1 <= end2; asc2 ? i < end2 : i > end2; asc2 ? i++ : i--) {
    var asc3;
    var end3;
    // eslint-disable-next-line benchlint/disallow-comma-operator
    for (j = 1, end3 = b.length + 1, asc3 = 1 <= end3; asc3 ? j < end3 : j > end3; asc3 ? j++ : j--) {
      if (a[i - 1] === b[j - 1]) {
        editDistances[i][j] = editDistances[i - 1][j - 1];
        edits[i][j] = EditAction.NO_CHANGE;
      } else {
        var substitution = editDistances[i - 1][j - 1] + 1;
        var deletion = editDistances[i - 1][j] + 1;
        var insertion = editDistances[i][j - 1] + 1;

        editDistances[i][j] = Math.min(substitution, insertion, deletion);
        edits[i][j] = (() => {
          switch (editDistances[i][j]) {
            case substitution:
              return EditAction.SUBSTITUTION;
            case insertion:
              return EditAction.INSERTION;
            case deletion:
              return EditAction.DELETION;
            default:
              // will never be hit but a default is required by TS
              return undefined;
          }
        })()!;
      }
    }
  }

  const baseEdits: Array<BaseEdit> = [];
  i = a.length;
  j = b.length;
  while (i > 0 || j > 0) {
    var type = edits[i][j];
    switch (type) {
      case EditAction.SUBSTITUTION:
        i--;
        j--;
        baseEdits.push({action: EditAction.SUBSTITUTION, initial: a[i], final: b[j], index: i});
        break;
      case EditAction.INSERTION:
        j--;
        baseEdits.push({action: EditAction.INSERTION, initial: '', final: b[j], index: i});
        break;
      case EditAction.DELETION:
        i--;
        baseEdits.push({action: EditAction.DELETION, initial: a[i], final: '', index: i});
        break;
      case EditAction.NO_CHANGE:
        i--;
        j--;
        break;
      default:
        break;
    }
  }

  return {baseEdits, distance: editDistances[a.length][b.length]};
}

// Not for general use.
function canBeCombined(
  current: {index: number; action: EditAction},
  edit: {index: number; action: EditAction}
): boolean | undefined {
  assert(edit.index <= current.index, "Edit index can't be after current index");
  return (
    current.action === edit.action &&
    (() => {
      switch (edit.action) {
        case EditAction.SUBSTITUTION:
        case EditAction.DELETION:
          return current.index - edit.index <= 1;
        case EditAction.INSERTION:
          return current.index === edit.index;
        default:
          return undefined;
      }
    })()
  );
}

/**
 * Merge together adjacent edits of the same type
 */
function convertBaseEditsToEdits(baseEdits: Array<BaseEdit>): Array<BaseEdit> {
  if (baseEdits.length === 0) {
    return [];
  }
  baseEdits = _.sortBy(baseEdits, ({index}) => -index);

  const edits = [];
  // eslint-disable-next-line no-restricted-syntax
  let current = _.first(baseEdits)!;
  // eslint-disable-next-line no-restricted-syntax
  for (const edit of Array.from(_.rest(baseEdits))) {
    if (canBeCombined(current, edit)) {
      current.initial = edit.initial + current.initial;
      current.final = edit.final + current.final;
      current.index = Math.min(current.index, edit.index);
    } else {
      edits.push(current);
      current = _.clone(edit);
    }
  }
  edits.push(current);
  return edits;
}

function getEdits(original: string, final: string): Array<BaseEdit> {
  let index;
  ({index, original, final} = extractModifiedRegion(original, final));
  const {baseEdits} = getBaseEdits(original, final);
  let offset = index;
  return _.sortBy(convertBaseEditsToEdits(baseEdits), 'index').map((edit) => {
    const reindexedEdit = reactUpdate(edit, {index: {$set: edit.index + offset}});
    offset += edit.final.length - edit.initial.length;
    return reindexedEdit;
  });
}

function applyEdit(bases: string, {index, initial, final}: Edit): string {
  return bases.slice(0, index) + final + bases.slice(index + initial.length);
}

export {
  EditAction,
  getBaseEdits as __getBaseEdits,
  convertBaseEditsToEdits as __convertBaseEditsToEdits,
  applyEdit as __applyEdit,
  extractModifiedRegion,
  getEdits,
};
